import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Image from '../elements/Image';
import { useTranslation } from '../../i18n/LanguageProvider';

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

const articleImages = [
  'https://i.ibb.co/wrBtCw6/christina-wocintechchat-com-7-PHq2-BCa7d-M-unsplash.jpg',
  'https://miro.medium.com/max/700/0*VIWtMtQMwg4uw44g',
  'https://images.unsplash.com/photo-1531747118685-ca8fa6e08806?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1045&q=80'
];

const BlogFeatured = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const { t } = useTranslation();

  const outerClasses = classNames(
    'blog-featured section center-content-mobile',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'blog-featured-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const articles = t('blogFeatured.articles').map((article, index) => ({
    ...article,
    image: articleImages[index] || articleImages[0]
  }));

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          {articles.map((article, index) => (
            <div className="split-wrap blog-featured-content" key={article.title}>
              {index === 0 && (
                <h1 className="reveal-from-bottom" data-reveal-delay="200">
                  <span className="text-color-primary">{t('blogFeatured.title')}</span>
                </h1>
              )}
              <div className="split-item reveal-from-left" data-reveal-delay="400">
                <div className="split-item-image center-content-mobile split-item-image-fill animate-zoom-in" data-reveal-container=".split-item">
                  <Image
                    src={article.image}
                    alt="blog-featured"
                    width={300}
                    height={200} />
                </div>
                <div className="split-item-content" data-reveal-container=".split-item">
                  <div className="blog-tags ta-l text-color-high mt-16">
                    {article.tags.map((tag, tagIndex) => (
                      <span
                        key={`${tag}-${tagIndex}`}
                        className={`blog-tag-subject blog-tag-subject--color-${(tagIndex % 5) + 1} text-xxs`}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <a className='blog-article-title' href={article.link}>
                    <h3 className='ta-l mt-8 mb-0'>{article.title}</h3>
                  </a>
                  <p className='ta-l mt-8 text-sm'>{article.description}</p>
                  <p className='ta-l text-xxs'>{article.author}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

BlogFeatured.propTypes = propTypes;
BlogFeatured.defaultProps = defaultProps;

export default BlogFeatured;
